import { useMemo, useState } from 'react';
import { useCart } from '../../../../../contexts/CartContext/CartContext.hooks';
import { useNavigate } from 'react-router-dom';
import CreditCheckCartRedirect from './CreditCheckCartRedirect/CreditCheckCartRedirect';
import CreditCheckPhoneNumberInput from './CreditCheckPhoneNumberInput/CreditCheckPhoneNumberInput';
import { SendCreditCheckAssistanceRequestEmail } from 'contexts/CartContext/CartContext.api';

export interface ICreditCheckFollowupBoxProps {
    followUpTitle?: string;
    followUpMessage?: string;
}

const CreditCheckFollowupBox = (props: ICreditCheckFollowupBoxProps) => {
    const { followUpTitle, followUpMessage } = props;
    const { cart, updateAgreements } = useCart();

    const [phoneNumber, setPhoneNumber] = useState(cart.customerInfo.phoneNumber);
    const phoneNumberRegex = /^[+]?[(]?\d{3}[)]?[-\s.]?\d{3}[-\s.]?\d{4,6}$/;

    const navigate = useNavigate();
    const onViewCartClick = () => {
        navigate('/cart');
        scrollTo(0, 0);
    };

    const onCallMeClick = () => {
        if (!phoneNumberRegex.test(phoneNumber)) return;
        const creditCheckInformation = {
            ...cart.agreements.creditCheckInformation,
            creditCheckPhoneNumber: phoneNumber,
            addedPhoneNumber: true
        };
        const agreements = {
            ...cart.agreements,
            creditCheckInformation: creditCheckInformation
        };
        updateAgreements(agreements);

        SendCreditCheckAssistanceRequestEmail({
            ...cart,
            agreements: { ...agreements }
        });
    };

    const FollowupBox = useMemo(() => {
        return !cart.agreements.creditCheckInformation.addedPhoneNumber ? (
            <CreditCheckPhoneNumberInput
                onClick={onCallMeClick}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                title={followUpTitle}
                message={followUpMessage}
            />
        ) : (
            <CreditCheckCartRedirect onClick={onViewCartClick} />
        );
    }, [cart.agreements.creditCheckInformation, phoneNumber, setPhoneNumber]);

    return <div>{FollowupBox}</div>;
};

export default CreditCheckFollowupBox;
